import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useState } from 'react';
import { SimplifiedWorkAssignment } from './AssignmentList';
import dayjs from 'dayjs';

const AssignmentCardWorkAssignment = ({
  workAssignment,
}: {
  workAssignment: SimplifiedWorkAssignment;
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <>
      <div
        className="p-2 m-2 border rounded border-neutral-500"
        onClick={() => setExpanded(!expanded)}
        role="button"
      >
        <div className="mb-2 p-2 d-flex align-items-center gap-2">
          {!expanded ? (
            <SharedIcon iconName="keyboard_arrow_right" size="sm" />
          ) : (
            <SharedIcon iconName="keyboard_arrow_down" size="sm" />
          )}
          {workAssignment.name}
        </div>
        {expanded && (
          <div className="px-2 pb-2">
            <div className="mb-1">
              <span className="weight-700">Overhead Position:</span>{' '}
              {`${workAssignment.overheadPosition ?? '---'}`}
            </div>
            <div className="mb-1">
              <span className="weight-700">Special Instructions:</span>{' '}
              {`${workAssignment.specialInstructions ?? '---'}`}
            </div>
            <div className="mb-1">
              <span className="weight-700">Reporting Location:</span>{' '}
              {`${workAssignment.reportingLocation ?? '---'}`}
            </div>
            <div className="mb-1">
              <span className="weight-700">Date / Time:</span>{' '}
              {`${dayjs(workAssignment.timestamp).format('MM/DD/YYYY HH:mm') ?? '---'}`}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssignmentCardWorkAssignment;
